/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ExpireCardOffersRequest": {
                "fields": {
                  "merchantTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "reason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExpireCardOffersResponse": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ExpireCardOffersRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ExpireCardOffersResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ExpireCardOffersRequest @ squareup/corporate_card/service/expire_card_offers.proto at 8:1
 */
export const ExpireCardOffersRequest = $root.lookupType('squareup.corporate_card.service.ExpireCardOffersRequest');
fixType(ExpireCardOffersRequest, {
  merchantTokens: {
    required: true
  }
});
Builder.createAndAttachToType(ExpireCardOffersRequest);
/**
 * SOURCE ExpireCardOffersResponse @ squareup/corporate_card/service/expire_card_offers.proto at 19:1
 */
export const ExpireCardOffersResponse = $root.lookupType('squareup.corporate_card.service.ExpireCardOffersResponse');
fixType(ExpireCardOffersResponse);
Builder.createAndAttachToType(ExpireCardOffersResponse);